import React from "react";
import { getLanguageFile } from "../../common/GetLanguageFile";

const ProgressBar = (props: { percentage: number; status?: string }) => {
  return (
    <div
      style={{
        background: "#fffa",
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: 10,
        boxSizing: "border-box",
        backdropFilter: "blur(2px)",
      }}
    >
      <span
        style={{
          whiteSpace: "nowrap",
          width: "100%",
          overflow: "hidden",
          textOverflow: "ellipsis",
          fontSize: "1.4rem",
          textAlign: "center",
          fontWeight: 800,
          color: "#444",
        }}
      >
        {props.status ?? getLanguageFile("generics.loading")}
      </span>
      <div
        style={{
          background: "#fff",
          width: "100%",
          height: "20px",
          borderRadius: "1rem",
          padding: 2,
          overflow: "hidden",
        }}
      >
        <div
          className="progress-bar"
          style={{
            width: `${props.percentage * 100}%`,
            animation: "width 100ms",
            height: "100%",
            borderRadius: "1rem",
          }}
        />
      </div>
    </div>
  );
};

export default ProgressBar;
